import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';
import { FilterOptionsState } from '@material-ui/lab';
import Autocomplete, {
  AutocompleteRenderOptionState,
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';

type InputProps = {
  label?: string;
  value: string;
  options: Array<SelectOption<string>>;
  onChange: (value: string) => void;
  onError?: (value: string | null) => void;
  autoFocus?: boolean;
  className?: string;
  error?: boolean;
  helperText?: string;
  renderOption?: (
    option: SelectOption<string>,
    state: AutocompleteRenderOptionState,
  ) => React.ReactNode;
  required?: boolean;
};

const filter = createFilterOptions<SelectOption<string>>();

export const UiAutocompleteFreeSolo = ({
  label,
  value,
  options,
  className,
  onChange,
  onError,
  autoFocus,
  error,
  helperText,
  renderOption,
  required,
}: InputProps) => {
  const [errorText, setErrorText] = useState<string | null>(null);
  const handleChange = (
    _e: React.ChangeEvent<{}>,
    option: SelectOption<string> | string | null,
  ) => {
    const newVal = typeof option === 'string' ? option : option?.value;
    onChange(newVal || '');

    if (required && newVal) {
      setErrorText(null);
      if (onError) {
        onError(null);
      }
    }
    if (required && !newVal) {
      setErrorText('Required');
      if (onError) {
        onError('Required');
      }
    }
  };

  const selectedOption = options.find((o) => o.value === value) || { value, label: value };

  const addOption = (
    opts: Array<SelectOption<string>>,
    params: FilterOptionsState<SelectOption<string>>,
  ) => {
    const filtered = filter(opts, params);

    const { inputValue } = params;
    // Suggest the creation of a new value
    const isExisting = opts.some((option) => inputValue === option.label);
    if (inputValue !== '' && !isExisting) {
      filtered.push({
        value: inputValue,
        label: `Add "${inputValue}"`,
      });
    }

    return filtered;
  };

  return (
    <Autocomplete
      className={className}
      blurOnSelect
      autoHighlight
      openOnFocus
      groupBy={(o) => o.groupBy || ''}
      options={options}
      filterOptions={addOption}
      onChange={handleChange}
      getOptionLabel={(o) => o.label || ''}
      value={selectedOption}
      freeSolo
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="dense"
          variant="outlined"
          autoFocus={autoFocus}
          error={Boolean(errorText) || error}
          helperText={errorText || helperText}
          required={required}
        />
      )}
      renderOption={renderOption}
    />
  );
};
